import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function base64ToBlob(base64: string, mime = 'application/octet-stream'): Blob {
  // Support data URLs like: data:image/png;base64,AAAA...
  let rawBase64 = base64;
  let resolvedMime = mime;
  const dataUrlMatch = /^data:([^;,]+)?(?:;base64)?,(.*)$/i.exec(base64);
  if (dataUrlMatch) {
    if (dataUrlMatch[1]) resolvedMime = dataUrlMatch[1];
    rawBase64 = dataUrlMatch[2];
  }

  // Remove whitespace and convert URL-safe base64 to standard
  rawBase64 = rawBase64.replace(/\s/g, '').replace(/-/g, '+').replace(/_/g, '/');

  // Fix missing padding
  const remainder = rawBase64.length % 4;
  if (remainder === 2) rawBase64 += '==';
  else if (remainder === 3) rawBase64 += '=';
  else if (remainder === 1) throw new Error('Invalid base64 string: incorrect length');

  let byteChars: string;
  try {
    byteChars = atob(rawBase64);
  } catch (e) {
    throw new Error('Failed to decode base64 content');
  }
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], { type: resolvedMime });
}
